import { render, staticRenderFns } from "./emailList.vue?vue&type=template&id=efc20866&scoped=true&"
import script from "./emailList.vue?vue&type=script&lang=js&"
export * from "./emailList.vue?vue&type=script&lang=js&"
import style0 from "./emailList.vue?vue&type=style&index=0&id=efc20866&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc20866",
  null
  
)

export default component.exports